import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Upload,
  Modal,
  Form,
  Input,
  Avatar,
  Tag,
  DatePicker,
  InputNumber,
} from "antd";
import React, { useState, useCallback, useContext, useEffect } from "react";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import dayjs from 'dayjs';
import { ToTopOutlined, ExclamationCircleOutlined, UploadOutlined } from "@ant-design/icons";
import useImageUploader from "../hooks/useImageUploader";
import { uploadFile } from 'react-s3';

const S3_BUCKET = 'sugamaya';
const REGION = 'us-east-1';
const ACCESS_KEY = 'AKIA6GBMIAPJULCPWKU5';
const SECRET_ACCESS_KEY = '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';

const config = {
  dirName: "taxi/banner",
  bucketName: S3_BUCKET,
  region: REGION,
  accessKeyId: ACCESS_KEY,
  secretAccessKey: SECRET_ACCESS_KEY,
}

function Banner() {

  const { request } = useRequest()
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [selected, setSelected] = useState();
  const [visible, setVisible] = useState(false);
  const { confirm } = Modal;
  const showConfirm = (record) => {

    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: <Button >Are you sure you want change the status ? </Button>,
        onOk() {
          statusChange(record)
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    }, 5);

  };


  const statusChange = (record) => {
    setLoading(true);
    request({
      url: `/admin/banner/status-change/${record}?`,
      method: 'PUT',
      onSuccess: (data) => {
        setRefresh(prev => !prev)
        setLoading(false);

      },
      onError: (error) => {
        console.log(error)
        ShowToast(error, Severty.ERROR)
      }
    })
  };
  const columns = [
    {
      title: "Banner Image",
      render: (_, { image }) => {
        return (
          <Avatar.Group>
            <Avatar
              className="shape-avatar"
              shape="square"
              size={60}
              src={image}
            ></Avatar>
          </Avatar.Group>
        )
      }
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",

    },

    {
      title: "Status",
      filters: [
        {
          text: 'Active',
          value: true,
        },
        {
          text: 'InActive',
          value: false,
        },
      ],
      onFilter: (value, record) => record.is_status === value,
      render: (_, { is_status, _id }) => {
        let color = is_status ? 'green' : 'red';
        return (
          <Tag onClick={(e) => showConfirm(_id)} color={color} key={is_status}>
            {is_status ? "Active" : "Inactive"}
          </Tag>
        );
      },
    },
    {
      title: "Created date",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return (
          new Date(created_at).toLocaleDateString()
        );
      },
    },
    {
      title: "Action",
      render: (_, record) => {
        return (
          <Button onClick={() => {
            setSelected(record)
            setVisible(true)
          }}>
            <i class="fa fa-light fa-pen"></i>
            Edit
          </Button>
        );
      },
    },
  ];
  useEffect(() => {
    setLoading(true)
    request({
      url: '/admin/banner/list',
      method: 'GET',
      onSuccess: (data) => {
        setLoading(false)
        // ShowToast(data.message, Severty.SUCCESS)
        setList(data.data.list)

      },
      onError: (error) => {
        console.log(error)
        ShowToast(error, Severty.ERROR)
      }
    })
  }, [refresh])
  return (
    <Main>
      <div className="tabled">
        <Row>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Banner Management"
              extra={
                <>
                  <Button onClick={(e) => setVisible(true)}>Add Banner</Button>
                </>
              }
            >
              <div className="table-responsive">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={true}
                  className="ant-border-space"
                />
              </div>
            </Card>


          </Col>
        </Row>
      </div>
      {visible && <AddFrom show={visible} hide={() => { setSelected(); setVisible(false) }} data={selected} refresh={() => setRefresh(prev => !prev)} />}
    </Main>
  );
}

const AddFrom = ({ show, hide, data, refresh }) => {
  const { request } = useRequest()
  const [loading, setLoading] = useState(false)
  const [fileInfo, setFileInfo] = useState(null);
  const [file, setFile] = useState([]);
  const FileType = ["image/png", "image/jpg", "image/jpeg"]
  const [form] = Form.useForm();

  const handleChange = async (event) => {
    const { file } = event
    setFile([file])

    console.log(file, "hello")
    uploadFile(file, config)
      .then(data => {
        const fileData = {
          uid: file.uid,
          name: file.name,
          status: 'done',
          url: data.location,
          thumbUrl: data.location,
        }
        setFile([fileData])
        console.log(data)
      }

      )
      .catch(err => console.error(err))
  };

  const onCreate = (values) => {
    console.log(file, "file")
    const {
      title,

    } = values
    const payload = {}
    setLoading(true)

    if (file.length < 0) {
      return ShowToast('Please upload the image', Severty.ERROR);
    }

    payload.title = title
    payload.imageUrl = file.length > 0 ? file[0].url : ''

    request({
      url: `${data ? `/admin/banner/edit-banner/${data._id}` : `/admin/banner/add-banner`}`,
      method: `${data ? 'PUT' : 'POST'}`,
      data: payload,
      onSuccess: (data) => {
        setLoading(false)
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS)
          hide()
          refresh()
        } else {
          ShowToast(data.message, Severty.ERROR)
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR)
        setLoading(false)
      },
    })
  };
  useEffect(() => {
    if (!data) return
    form.setFieldsValue({ ...data })
    data.image && setFile([data.image])


  }, [data])

  return (
    <Modal
      open={show}
      title="Create a new Banner"
      okText="Ok"
      onCancel={hide}
      okButtonProps={{
        form: 'create',
        htmlType: 'submit',
        loading: loading,
      }}
    >
      <Form
        id="create"
        form={form}
        layout="vertical"
        onFinish={onCreate}
        style={{
          maxWidth: 600,
        }}
      >

        <Row>
          <Col span={24}>
            <Form.Item
              label="Banner Title"
              name="title"
              rules={[

                { required: true, message: "Please input the title!" }
              ]}
            >
              <Input />
            </Form.Item>
          </Col>


          <Col span={24}>
            <Form.Item

              label="Banner Image"
            >


              <Upload
                listType="picture"
                maxCount={1}
                customRequest={handleChange}
                onRemove={(e) => setFile([])}
                fileList={file}
              >
                {file.length > 0 ? null : <Button icon={<UploadOutlined />}>Upload</Button>}
              </Upload>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

export default Banner;
